import { Box } from '@mui/material';

const TabPanel = (props) => {
  const { children, value, index } = props;
  const isActive = value === index;

  return (
    <Box
      role="tabpanel"
      hidden={!isActive}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      // The active panel fills its parent so a full-height table inside can put its pager at the bottom.
      sx={isActive ? { display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, height: '100%' } : undefined}>
      {isActive && children}
    </Box>
  );
};

export default TabPanel;
